import { render, staticRenderFns } from "./CalendarSidebar.vue?vue&type=template&id=033981ef&scoped=true"
import script from "./CalendarSidebar.vue?vue&type=script&lang=js"
export * from "./CalendarSidebar.vue?vue&type=script&lang=js"
import style0 from "./CalendarSidebar.vue?vue&type=style&index=0&id=033981ef&prod&scoped=true&lang=css"
import style1 from "./CalendarSidebar.vue?vue&type=style&index=1&id=033981ef&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "033981ef",
  null
  
)

export default component.exports